import { render, staticRenderFns } from "./PackageAdd.vue?vue&type=template&id=a01d83e0&scoped=true&"
import script from "./PackageAdd.vue?vue&type=script&lang=js&"
export * from "./PackageAdd.vue?vue&type=script&lang=js&"
import style0 from "./PackageAdd.vue?vue&type=style&index=0&id=a01d83e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01d83e0",
  null
  
)

export default component.exports